export const PHASE_DUR = { takeoff: 9, landing: 11 };
